import React from "react";
import ViewFormCheckbox from "./ViewFormCheckbox";

const ViewFormCheckboxGroup = ({
  index,
  title,
  answer,
  setAnswer,
  options,
}) => {
  const handleChange = (val) => {
    const updatedAnswer = answer.includes(val)
      ? answer.filter((item) => item !== val) // remove item
      : [...answer, val]; // add it
    setAnswer(index, updatedAnswer);
  };

  return (
    <div className="form-group">
      <label>{title}</label>
      {options.map((option, index) => (
        <ViewFormCheckbox
          key={index}
          value={option}
          handleChange={handleChange}
        />
      ))}
    </div>
  );
};

export default ViewFormCheckboxGroup;
